module.exports = __webpack_public_path__ + "static/media/case-study-a&b-mylec.541d4e22.pdf";